import { FiltersDto } from "api/dtos/FiltersDto";
import axiosInstance from "api/utils/axiosInstance";
import { URLS } from "api/utils/baseUrls";

const getDashboardFilters = async () => {
  try {
    const res = await axiosInstance.get(
      `${URLS.filters}/?filter_type=kyd_dashboard`
    );
    const data = FiltersDto.fromApiPaginated(res.data);
    return data;
  } catch (err) {
    console.error("Error fetching filter types:", err);
    throw err;
  }
};

const getDashboardFilter = async (id) => {
  try {
    const res = await axiosInstance.get(`${URLS.filters}/${id}/`);
    const data = FiltersDto.fromApi(res.data);
    return data;
  } catch (err) {
    console.error("Error fetching filter types:", err);
    throw err;
  }
};

const createDashboardFilter = async (data) => {
  try {
    const payload = FiltersDto.toApi(data);
    const res = await axiosInstance.post(`${URLS.filters}/`, payload);
    return FiltersDto.fromApi(res.data);
  } catch (err) {
    throw err;
  }
};

const editDashboardFilter = async (id, data) => {
  try {
    const payload = FiltersDto.toApi(data);
    const res = await axiosInstance.patch(`${URLS.filters}/${id}/`, payload);
    return FiltersDto.fromApi(res.data);
  } catch (err) {
    throw err;
  }
};

const deleteDashboardFilter = async (id) => {
  try {
    await axiosInstance.delete(`${URLS.filters}/${id}/`);
  } catch (err) {
    throw err;
  }
};

export const filtersApi = {
  dashboard: {
    fetchAll: getDashboardFilters,
    fetchOne: getDashboardFilter,
    create: createDashboardFilter,
    edit: editDashboardFilter,
    delete: deleteDashboardFilter,
  },
};
